<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        style="padding-top:10px"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>
    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required|min:6|max:40'"
        type="password"
        name="password"
        icon-no-border
        style="padding-top:10px"
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Contraseña"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    <div style="padding-top:10px" class="flex flex-wrap justify-between my-5">
        <!--vs-checkbox v-model="checkbox_remember_me" class="mb-3">Recordarme</vs-checkbox-->
        <router-link to="/pages/forgot-password">Recuperar contraseña</router-link>
    </div>
    <!--vs-button  type="border" @click="registerUser">Registrarme</vs-button-->
    <vs-button class="float-right" :disabled="!validateForm" @click="login">Iniciar sesión</vs-button>
   
    </div>
</template>
<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    login () {
      // Loading
      this.$vs.loading();
      this.$http.post('App','login',{ email: this.email, password: this.password },(data)=>{
        if(!data) {
          this.$vs.notify({
            time: 2500,
            title: 'Error',
            text: "Email o password invalido!",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        } else {
          this.$http.setToken(data);
          this.$router.push('/').catch(() => {});
        }
        this.$vs.loading.close();
      });
    }
  },
  mounted(){
    this.$vs.loading();
    this.$http.post('App','checkLogin',{ email: this.email, password: this.password },(data)=>{
        if(data) {
          this.$router.push('/').catch(() => {});
        }
        this.$vs.loading.close();
    });
  }
}
</script>
<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>